﻿//Smooth Scroll Polyfill
!(function () {
  "use strict";
  function o() {
    var o = window,
      t = document;
    if (
      !(
        "scrollBehavior" in t.documentElement.style &&
        !0 !== o.__forceSmoothScrollPolyfill__
      )
    ) {
      var l,
        e = o.HTMLElement || o.Element,
        r = 468,
        i = {
          scroll: o.scroll || o.scrollTo,
          scrollBy: o.scrollBy,
          elementScroll: e.prototype.scroll || n,
          scrollIntoView: e.prototype.scrollIntoView,
        },
        s =
          o.performance && o.performance.now
            ? o.performance.now.bind(o.performance)
            : Date.now,
        c =
          ((l = o.navigator.userAgent),
          new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(l) ? 1 : 0);
      (o.scroll = o.scrollTo =
        function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? h.call(
                  o,
                  t.body,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : o.scrollY || o.pageYOffset
                )
              : i.scroll.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : o.scrollX || o.pageXOffset,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : o.scrollY || o.pageYOffset
                ));
        }),
        (o.scrollBy = function () {
          void 0 !== arguments[0] &&
            (f(arguments[0])
              ? i.scrollBy.call(
                  o,
                  void 0 !== arguments[0].left
                    ? arguments[0].left
                    : "object" != typeof arguments[0]
                    ? arguments[0]
                    : 0,
                  void 0 !== arguments[0].top
                    ? arguments[0].top
                    : void 0 !== arguments[1]
                    ? arguments[1]
                    : 0
                )
              : h.call(
                  o,
                  t.body,
                  ~~arguments[0].left + (o.scrollX || o.pageXOffset),
                  ~~arguments[0].top + (o.scrollY || o.pageYOffset)
                ));
        }),
        (e.prototype.scroll = e.prototype.scrollTo =
          function () {
            if (void 0 !== arguments[0])
              if (!0 !== f(arguments[0])) {
                var o = arguments[0].left,
                  t = arguments[0].top;
                h.call(
                  this,
                  this,
                  void 0 === o ? this.scrollLeft : ~~o,
                  void 0 === t ? this.scrollTop : ~~t
                );
              } else {
                if ("number" == typeof arguments[0] && void 0 === arguments[1])
                  throw new SyntaxError("Value could not be converted");
                i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left
                    : "object" != typeof arguments[0]
                    ? ~~arguments[0]
                    : this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top
                    : void 0 !== arguments[1]
                    ? ~~arguments[1]
                    : this.scrollTop
                );
              }
          }),
        (e.prototype.scrollBy = function () {
          void 0 !== arguments[0] &&
            (!0 !== f(arguments[0])
              ? this.scroll({
                  left: ~~arguments[0].left + this.scrollLeft,
                  top: ~~arguments[0].top + this.scrollTop,
                  behavior: arguments[0].behavior,
                })
              : i.elementScroll.call(
                  this,
                  void 0 !== arguments[0].left
                    ? ~~arguments[0].left + this.scrollLeft
                    : ~~arguments[0] + this.scrollLeft,
                  void 0 !== arguments[0].top
                    ? ~~arguments[0].top + this.scrollTop
                    : ~~arguments[1] + this.scrollTop
                ));
        }),
        (e.prototype.scrollIntoView = function () {
          if (!0 !== f(arguments[0])) {
            var l = (function (o) {
                for (
                  ;
                  o !== t.body &&
                  !1 ===
                    ((e = p((l = o), "Y") && a(l, "Y")),
                    (r = p(l, "X") && a(l, "X")),
                    e || r);

                )
                  o = o.parentNode || o.host;
                var l, e, r;
                return o;
              })(this),
              e = l.getBoundingClientRect(),
              r = this.getBoundingClientRect();
            l !== t.body
              ? (h.call(
                  this,
                  l,
                  l.scrollLeft + r.left - e.left,
                  l.scrollTop + r.top - e.top
                ),
                "fixed" !== o.getComputedStyle(l).position &&
                  o.scrollBy({ left: e.left, top: e.top, behavior: "smooth" }))
              : o.scrollBy({ left: r.left, top: r.top, behavior: "smooth" });
          } else
            i.scrollIntoView.call(
              this,
              void 0 === arguments[0] || arguments[0]
            );
        });
    }
    function n(o, t) {
      (this.scrollLeft = o), (this.scrollTop = t);
    }
    function f(o) {
      if (
        null === o ||
        "object" != typeof o ||
        void 0 === o.behavior ||
        "auto" === o.behavior ||
        "instant" === o.behavior
      )
        return !0;
      if ("object" == typeof o && "smooth" === o.behavior) return !1;
      throw new TypeError(
        "behavior member of ScrollOptions " +
          o.behavior +
          " is not a valid value for enumeration ScrollBehavior."
      );
    }
    function p(o, t) {
      return "Y" === t
        ? o.clientHeight + c < o.scrollHeight
        : "X" === t
        ? o.clientWidth + c < o.scrollWidth
        : void 0;
    }
    function a(t, l) {
      var e = o.getComputedStyle(t, null)["overflow" + l];
      return "auto" === e || "scroll" === e;
    }
    function d(t) {
      var l,
        e,
        i,
        c,
        n = (s() - t.startTime) / r;
      (c = n = n > 1 ? 1 : n),
        (l = 0.5 * (1 - Math.cos(Math.PI * c))),
        (e = t.startX + (t.x - t.startX) * l),
        (i = t.startY + (t.y - t.startY) * l),
        t.method.call(t.scrollable, e, i),
        (e === t.x && i === t.y) || o.requestAnimationFrame(d.bind(o, t));
    }
    function h(l, e, r) {
      var c,
        f,
        p,
        a,
        h = s();
      l === t.body
        ? ((c = o),
          (f = o.scrollX || o.pageXOffset),
          (p = o.scrollY || o.pageYOffset),
          (a = i.scroll))
        : ((c = l), (f = l.scrollLeft), (p = l.scrollTop), (a = n)),
        d({
          scrollable: c,
          method: a,
          startTime: h,
          startX: f,
          startY: p,
          x: e,
          y: r,
        });
    }
  }
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = { polyfill: o })
    : o();
})();

//Classlist Polyfill for IE < 10
/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
"document" in self &&
  (("classList" in document.createElement("_") &&
    (!document.createElementNS ||
      "classList" in
        document.createElementNS("http://www.w3.org/2000/svg", "g"))) ||
    !(function (t) {
      "use strict";
      if ("Element" in t) {
        var e = "classList",
          n = "prototype",
          i = t.Element[n],
          s = Object,
          r =
            String[n].trim ||
            function () {
              return this.replace(/^\s+|\s+$/g, "");
            },
          o =
            Array[n].indexOf ||
            function (t) {
              for (var e = 0, n = this.length; n > e; e++)
                if (e in this && this[e] === t) return e;
              return -1;
            },
          c = function (t, e) {
            (this.name = t), (this.code = DOMException[t]), (this.message = e);
          },
          a = function (t, e) {
            if ("" === e)
              throw new c("SYNTAX_ERR", "The token must not be empty.");
            if (/\s/.test(e))
              throw new c(
                "INVALID_CHARACTER_ERR",
                "The token must not contain space characters."
              );
            return o.call(t, e);
          },
          l = function (t) {
            for (
              var e = r.call(t.getAttribute("class") || ""),
                n = e ? e.split(/\s+/) : [],
                i = 0,
                s = n.length;
              s > i;
              i++
            )
              this.push(n[i]);
            this._updateClassName = function () {
              t.setAttribute("class", this.toString());
            };
          },
          u = (l[n] = []),
          h = function () {
            return new l(this);
          };
        if (
          ((c[n] = Error[n]),
          (u.item = function (t) {
            return this[t] || null;
          }),
          (u.contains = function (t) {
            return ~a(this, t + "");
          }),
          (u.add = function () {
            var t,
              e = arguments,
              n = 0,
              i = e.length,
              s = !1;
            do (t = e[n] + ""), ~a(this, t) || (this.push(t), (s = !0));
            while (++n < i);
            s && this._updateClassName();
          }),
          (u.remove = function () {
            var t,
              e,
              n = arguments,
              i = 0,
              s = n.length,
              r = !1;
            do
              for (t = n[i] + "", e = a(this, t); ~e; )
                this.splice(e, 1), (r = !0), (e = a(this, t));
            while (++i < s);
            r && this._updateClassName();
          }),
          (u.toggle = function (t, e) {
            var n = this.contains(t),
              i = n ? e !== !0 && "remove" : e !== !1 && "add";
            return i && this[i](t), e === !0 || e === !1 ? e : !n;
          }),
          (u.replace = function (t, e) {
            var n = a(t + "");
            ~n && (this.splice(n, 1, e), this._updateClassName());
          }),
          (u.toString = function () {
            return this.join(" ");
          }),
          s.defineProperty)
        ) {
          var f = { get: h, enumerable: !0, configurable: !0 };
          try {
            s.defineProperty(i, e, f);
          } catch (p) {
            (void 0 !== p.number && -2146823252 !== p.number) ||
              ((f.enumerable = !1), s.defineProperty(i, e, f));
          }
        } else s[n].__defineGetter__ && i.__defineGetter__(e, h);
      }
    })(self),
  (function () {
    "use strict";
    var t = document.createElement("_");
    if ((t.classList.add("c1", "c2"), !t.classList.contains("c2"))) {
      var e = function (t) {
        var e = DOMTokenList.prototype[t];
        DOMTokenList.prototype[t] = function (t) {
          var n,
            i = arguments.length;
          for (n = 0; i > n; n++) (t = arguments[n]), e.call(this, t);
        };
      };
      e("add"), e("remove");
    }
    if ((t.classList.toggle("c3", !1), t.classList.contains("c3"))) {
      var n = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (t, e) {
        return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
      };
    }
    "replace" in document.createElement("_").classList ||
      (DOMTokenList.prototype.replace = function (t, e) {
        var n = this.toString().split(" "),
          i = n.indexOf(t + "");
        ~i &&
          ((n = n.slice(i)),
          this.remove.apply(this, n),
          this.add(e),
          this.add.apply(this, n.slice(1)));
      }),
      (t = null);
  })());

//Closest Polyfill for IE9
Element.prototype.matches ||
  (Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector),
  Element.prototype.closest ||
    (Element.prototype.closest = function (e) {
      var t = this;
      do {
        if (t.matches(e)) return t;
        t = t.parentElement || t.parentNode;
      } while (null !== t && 1 === t.nodeType);
      return null;
    });

//Query Selector Shortcuts
var qs = function (s, o) {
  return (o || document).querySelector(s);
};
var qsa = function (s, o) {
  return (o || document).querySelectorAll(s);
};

//Change All Classes
function addClassAll(items, className) {
  for (var i = 0; i < items.length; i++) {
    items[i].classList.add(className);
  }
}
function removeClassAll(items, className) {
  for (var i = 0; i < items.length; i++) {
    items[i].classList.remove(className);
  }
}
function toggleClassAll(items, className) {
  for (var i = 0; i < items.length; i++) {
    items[i].classList.toggle(className);
  }
}

// Tab
document.body.addEventListener("mousedown", function () {
  document.body.classList.remove("using-tab");
});
document.body.addEventListener("keydown", function (event) {
  if (event.keyCode === 9) {
    document.body.classList.add("using-tab");
  }
});

//Form Label Hide
setLabelState();
function setLabelState() {
  var labelOnTop = qsa(".label-ontop");
  for (var i = 0; i < labelOnTop.length; i++) {
    if (
      labelOnTop[i].parentNode.querySelector("input, select, textarea").value ==
      ""
    ) {
      labelOnTop[i].classList.add("label-full");
    } else {
      labelOnTop[i].classList.remove("label-full");
    }
  }
}
document.addEventListener("focusin", function (e) {
  if (e.target.closest("input, select, textarea")) {
    if (e.target.parentNode.querySelector(".label-ontop")) {
      e.target.parentNode
        .querySelector(".label-ontop")
        .classList.remove("label-full");
    }
  }
});
document.addEventListener("focusout", function (e) {
  if (e.target.closest("input, select, textarea")) {
    if (
      e.target.parentNode.querySelector(".label-ontop") &&
      e.target.value == ""
    ) {
      e.target.parentNode
        .querySelector(".label-ontop")
        .classList.add("label-full");
    }
  }
});

//Form Swap
var loginBtns = qsa(".btn-login");
for (i = 0; i < loginBtns.length; i++) {
  loginBtns[i].addEventListener("click", function (e) {
    if (qs(".login-form")) {
      e.preventDefault();
      removeClassAll(qsa(".form-open"), "form-open");
      var loginForm = document.getElementById(this.hash.substr(1));
      loginForm.classList.add("form-open");
      qs(".login-box").style.height = loginForm.scrollHeight + "px";
      qs(".login-inner").scrollTo({ top: 0, behavior: "smooth" });
    }
  });
}
function loginHeight() {
  if (qs(".login-box .form-open")) {
    //qs('.login-box').style.height = qs('.login-box .form-open').scrollHeight + 'px';
  }
}
window.addEventListener("resize", function () {
  throttle(loginHeight, 200);
});
window.addEventListener("DOMContentLoaded", function () {
  loginHeight();
});

//Throttle
var throttleTimer = false;
function throttle(callback, time) {
  if (throttleTimer) return;
  throttleTimer = true;
  setTimeout(function () {
    callback();
    throttleTimer = false;
  }, time);
}

//Profile Icon
profileIcon();
function profileIcon() {
  var icons = qsa(".profile__icon");
  for (var i = 0; i < icons.length; i++) {
    var str = icons[i].innerHTML;
    var c1 = str.toUpperCase().charCodeAt(0) - 65 || 0;
    var c2 = str.toUpperCase().charCodeAt(1) - 65 || 0;
    var h = ((c1 + c2) / 50) * 360;
    var s = (c2 / 25) * 80 + 20;
    var l = (c2 % 3) * 20 + 30;
    icons[i].style.backgroundColor = "hsl(" + h + ", " + s + "%, " + l + "%)";
  }
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".modal-profile") && qs(".profile__menu")) {
    e.preventDefault();
    qs(".header-menu")?.classList.remove("open");
    qs(".profile__menu").classList.toggle("open");
  }
});

//Profile menu — keyboard activation (SRA003-387: .modal-profile is now an <a>
//without href, so restore the Enter/Space activation the href used to provide;
//mirrors the click handler above).
document.addEventListener("keydown", function (e) {
  if (
    (e.key === "Enter" || e.key === " " || e.key === "Spacebar") &&
    e.target.closest(".modal-profile") &&
    qs(".profile__menu")
  ) {
    e.preventDefault();
    qs(".header-menu")?.classList.remove("open");
    qs(".profile__menu").classList.toggle("open");
  }
});

//Header Menu
document.addEventListener("click", function (e) {
  if (e.target.closest(".btn-menu") && qs(".header-menu")) {
    e.preventDefault();
    qs(".profile__menu")?.classList.remove("open");
    qs(".header-menu").classList.toggle("open");
  }
});

//Close
document.addEventListener("click", function (e) {
  if (e.target.closest(".close, .close-modal")) {
    e.preventDefault();
    //closeAll();
  }
  if (
    !e.target.closest(
      ".modal-box, .modal-open, .profile__menu, .modal-profile, .btn-menu, .header-menu"
    )
  ) {
    //closeAll();
  }
  if (e.target.classList.contains("overlay")) {
    //closeAll();
  }
});

document.body.addEventListener("keydown", function (event) {
  if (event.keyCode === 27) {
    //closeAll();
  }
});

function closeAll() {
  removeClassAll(qsa(".open"), "open");
  if (qs(".modal-open")) {
    qs(".modal-open").focus();
  }
  removeClassAll(qsa(".modal-open"), "modal-open");
  document.body.removeAttribute("style");
}

//Open Modals
function openModal(btn, modal, relative, subMenu) {
  if (qs(btn) && qs(modal)) {
    document.addEventListener("click", function (e) {
      if (e.target.closest(btn)) {
        var thisBtn = e.target.closest(btn);
        if (relative) {
          var thisModal = thisBtn.closest(modal);
        } else {
          var thisModal = qs(modal);
        }
        e.preventDefault();
        e.stopPropagation();
        if (thisModal.classList.contains("open")) {
          thisModal.classList.remove("open");
          thisBtn.classList.remove("modal-open");
          if (subMenu) {
            thisModal.querySelector("ul").removeAttribute("style");
          }
        } else {
          thisModal.classList.add("open");
          thisBtn.classList.add("modal-open");
        }
      }
    });
  }
}

openModal(".btn__profile", ".profile__wrap", true);

//Modals by Id
function openSingleModal(btn, modal) {
  if (modal.classList.contains("open")) {
    closeAll();
  } else {
    closeAll();
    modalBtn = btn;
    document.body.setAttribute(
      "style",
      "overflow:hidden; padding-right:" + getScrollbarWidth() + "px;"
    );
    modal.classList.add("open");
    modal.setAttribute("tabindex", 1);
    setTimeout(function () {
      modal
        .querySelector(
          "a, area, button, input:not([hidden]), object, select, textarea"
        )
        .focus();
    }, 600);
  }
}

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

document.addEventListener("click", function (e) {
  if (e.target.closest("a")) {
    var a = e.target.closest("a");
    if (a.hash.substr(1)) {
      if (document.getElementById(a.hash.substr(1))) {
        if (
          document
            .getElementById(a.hash.substr(1))
            .classList.contains("overlay")
        ) {
          var btn = e.target.closest("a");
          var modal = document.getElementById(
            e.target.closest("a").hash.substr(1)
          );
          openSingleModal(btn, modal);
          e.preventDefault();
        }
      }
    }
  }
});

//Number Fields
var numTimer;

function numRemove(id) {
  let input = document.querySelector(id);
  if (!input.disabled) {
    var step = 1; //input.getAttribute('step') || 1;
    var val = input.value || 0;
    var newVal = Number(val) - Number(step);
    input.value = newVal;
    //input.dispatchEvent(new Event('change'));
    // numTimer = setTimeout(function() {
    // 	numRemove(id);
    // }, 200);
  }
}

function numAdd(id) {
  let input = document.querySelector(id);

  if (!input.disabled) {
    var step = 1; //input.getAttribute('step') || 1;
    var val = input.value || 0;
    var newVal = Number(val) + Number(step);
    input.value = newVal;
    //input.dispatchEvent(new Event('change'));

    // numTimer = setTimeout(function() {
    // 	numAdd(id);
    // }, 200);
  }
}

// document.addEventListener('mousedown', function(e) {
// 	if (e.target.closest('.number-add')) {
// 		numAdd(e.target.parentNode.querySelector('input'));
// 	} else if (e.target.closest('.number-remove')) {
// 		numRemove(e.target.parentNode.querySelector('input'));
// 	};
// });

document.addEventListener("mouseup", function (e) {
  clearTimeout(numTimer);
});

function addNumberControls() {
  var numFields = document.querySelectorAll('input[type="number"]');
  for (i = 0; i < numFields.length; i++) {
    if (numFields[i].closest(".number")) {
      if (!numFields[i].closest(".number").querySelector("button")) {
        numFields[i].parentNode.insertAdjacentHTML(
          "afterbegin",
          '<button type="button" class="number-remove"></button>'
        );
        numFields[i].parentNode.insertAdjacentHTML(
          "beforeend",
          '<button type="button" class="number-add"></button>'
        );
      }
    }
  }
}

addNumberControls();
window.addEventListener("load", function () {
  if (window.jQuery) {
    $(document).ajaxSuccess(addNumberControls);
  }
});

//Reset Number
// addReset();
// function addReset() {
// 	var resetFields = document.querySelectorAll('.reset');
// 	for(i=0; i < resetFields.length; i++) {
// 		if (!resetFields[i].querySelector('button')) {
// 			resetFields[i].insertAdjacentHTML('beforeend', '<button type="button" class="btn-reset"></button>');
// 		};
// 	};
// };

// document.addEventListener('click', function(e) {
// 	if (e.target.closest('.btn-reset')) {
// 		e.preventDefault();
// 		var input = e.target.parentNode.querySelector('input');
// 		input.value = input.getAttribute('data-reset');
// 	};
// });

//Fixed Cost Calc
setHarvesterCalc();
function setHarvesterCalc() {
  var calcFields = qsa(".calc-field");
  var harv = document.getElementById("harvester-num");
  for (var i = 0; i < calcFields.length; i++) {
    var calc = calcFields[i].querySelector("input");
    var total = calcFields[i]
      .closest(".fieldwrap")
      .querySelector(".number input");
    setCalcChange(calc, total, harv);
  }
  if (harv) {
    harv.addEventListener("change", function () {
      harvChange(calcFields, calc, total, harv);
    });
    harv.addEventListener("input", function () {
      harvChange(calcFields, calc, total, harv);
    });
  }
}

function harvChange(calcFields, calc, total, harv) {
  var fullTotal = 0;
  for (var i = 0; i < calcFields.length; i++) {
    var calc = calcFields[i].querySelector("input");
    var total = calcFields[i]
      .closest(".fieldwrap")
      .querySelector(".number input");
    calc.value = +parseFloat(Number(total.value) / Number(harv.value)).toFixed(
      2
    );
    fullTotal = fullTotal + Number(total.value);
  }
  qs(".calc-total").innerText = (+parseFloat(fullTotal).toFixed(
    2
  )).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  qs(".calc-harv").innerText = (+parseFloat(fullTotal / harv.value).toFixed(
    2
  )).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function setCalcChange(calc, total, harv) {
  total.addEventListener("change", function () {
    calcChange(calc, total, harv);
  });
  total.addEventListener("input", function () {
    calcChange(calc, total, harv);
  });
}

function calcChange(calc, total, harv) {
  calc.value = +parseFloat(Number(total.value) / Number(harv.value)).toFixed(2);
  var fullTotal = 0;
  var calcFields = qsa(".calc-field");
  for (var i = 0; i < calcFields.length; i++) {
    fullTotal =
      fullTotal +
      Number(
        calcFields[i].closest(".fieldwrap").querySelector(".number input").value
      );
  }
  qs(".calc-total").innerText = (+parseFloat(fullTotal).toFixed(
    2
  )).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  qs(".calc-harv").innerText = (+parseFloat(fullTotal / harv.value).toFixed(
    2
  )).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

//Expand
var expands = qsa(".expand-header");
for (i = 0; i < expands.length; i++) {
  expandClick(i);
}
function expandClick(i) {
  expands[i].addEventListener("click", function (e) {
    expandOpen(expands[i].closest(".expand"));
    e.stopPropagation();
  });
  if (expands[i].closest(".expand").classList.contains("expand-open")) {
    var expandContent = expands[i]
      .closest(".expand")
      .querySelector(".expand-content");
    var paddingH = expandContent.clientHeight;
    var h = expandContent.scrollHeight - paddingH;
    expandContent.style.height = h + "px";
    setTimeout(function () {
      expandContent.style.overflow = "visible";
    }, 500);
  }
}

function expandOpen(expand) {
  var expandContent = expand.querySelector(".expand-content");
  if (expand.classList.contains("expand-open")) {
    expand.classList.remove("expand-open");
    expandContent.removeAttribute("style");
  } else {
    expand.classList.add("expand-open");
    var h = expandContent.scrollHeight;
    expandContent.style.height = h + "px";
    setTimeout(function () {
      expandContent.style.overflow = "visible";
    }, 500);
  }
}

//Resize Expand on Window Resize
window.addEventListener("resize", function () {
  for (i = 0; i < expands.length; i++) {
    if (expands[i].closest(".expand").classList.contains("expand-open")) {
      var expandContent = expands[i]
        .closest(".expand")
        .querySelector(".expand-content");
      expandContent.style.height = "auto";
      var h = expandContent.scrollHeight;
      var p =
        parseFloat(getComputedStyle(expandContent).paddingTop) +
        parseFloat(getComputedStyle(expandContent).paddingBottom);
      expandContent.style.height = h - p + "px";
    }
  }
});

//Open Expand from URL Hash
if (window.location.hash) {
  if (window.location.hash.split("#")[1]) {
    var hash = "" + window.location.hash.split("#")[1];
    if (document.getElementById(hash)) {
      if (document.getElementById(hash).classList.contains("expand")) {
        expandOpen(document.getElementById(hash));
      }
    }
  }
}

// Show/Hide Checkbox
document.addEventListener("click", function (e) {
  if (e.target.closest("[data-reveal]")) {
    var check = e.target.closest("[data-reveal]");
    var id = check.getAttribute("data-reveal");
    var el = document.getElementById(id);
    if (check.checked == true) {
      el.classList.add("hidden");
    } else {
      el.classList.remove("hidden");
    }
  }
});

//Chioces
var blockSelect = document.querySelectorAll(".block-select");
for (var i = 0; i < blockSelect.length; i++) {
  var choices = new Choices(blockSelect[i], {
    removeItemButton: true,
    searchEnabled: false,
    searchChoices: false,
  });
}
